import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import companyData from "../../Data/CompanyData";
import categories from "../../Data/Categories";
import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";

const estadoVariant = (estado) => {
  if (estado === "ganador") return "default";
  if (estado === "rechazada") return "destructive";
  if (estado === "aceptada") return "secondary";
  return "outline";
};

const InfoPostulaciones = ({ applications, page, totalPages, setPage }) => {
  const [localApplications, setLocalApplications] = useState(applications);
  const navigate = useNavigate();
  const allCategories = [...categories, ...companyData.sectores];

  useEffect(() => {
    if (JSON.stringify(localApplications) !== JSON.stringify(applications)) {
      setLocalApplications(applications);
    }
  }, [applications]);

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const renderPaginationButtons = () => {
    const pages = [];

    if (page > 1) {
      pages.push(page - 1);
    }

    pages.push(page);

    if (page < totalPages) {
      pages.push(page + 1);
    }

    return pages;
  };

  return (
    <div className="mb-24 flex flex-col gap-4">
      {localApplications.length > 0 ? (
        localApplications.map((application) => (
          <Card key={application.id_application}>
            <CardContent className="flex flex-col gap-3 p-4 sm:p-5">
              <h4 className="text-center font-semibold">
                {application.tender ? (
                  <Link
                    className="text-primary underline-offset-2 hover:underline"
                    to={`/ver-licitacion/${application.tender.id_tender}/${application.tender.titulo}`}
                  >
                    {application.tender.titulo.length > 80
                      ? application.tender.titulo.substring(0, 80) + "..."
                      : application.tender.titulo}
                  </Link>
                ) : (
                  <span className="text-primary">Licitación no disponible</span>
                )}
              </h4>

              <div className="flex flex-col gap-3 text-sm text-muted-foreground sm:flex-row sm:justify-evenly">
                <div className="hidden sm:block sm:basis-1/5">
                  {application.tender &&
                  allCategories.some((cat) =>
                    application.tender.categoria?.includes(cat.label)
                  ) ? (
                    allCategories.map(
                      (cat) =>
                        application.tender.categoria?.includes(cat.label) && (
                          <div key={cat.label} className="flex items-center gap-1">
                            <span>{cat.icon}</span>
                            <h4 className="font-medium text-foreground">
                              {application.tender.categoria}
                            </h4>
                          </div>
                        )
                    )
                  ) : (
                    <div className="flex items-center gap-1">
                      <span>⚙️</span>
                      <h4 className="font-medium text-foreground">
                        {application.tender
                          ? application.tender.categoria
                          : "Categoría desconocida"}
                      </h4>
                    </div>
                  )}
                </div>

                <div className="flex flex-col gap-1 sm:basis-4/5">
                  <p>
                    <strong className="text-foreground">Fecha de creación de licitación:</strong>{" "}
                    {application.tender ? application.tender.created_at : "N/A"}
                  </p>
                  <p>
                    <strong className="text-foreground">Fecha de postulación:</strong>{" "}
                    {application.updated_at}
                  </p>
                  <p>
                    <strong className="text-foreground">Nº Licitación:</strong>{" "}
                    {application.tender ? application.tender.id_tender : "N/A"}
                  </p>
                  <p>
                    <strong className="text-foreground">Nº Postulación:</strong>{" "}
                    {application.tender ? application.id_application : "N/A"}
                  </p>
                  <p>
                    <strong className="text-foreground">Detalle de la postulacion:</strong>{" "}
                    {application.tender ? application.detalles_oferta : "N/A"}
                  </p>
                  <p className="flex items-center gap-2">
                    <strong className="text-foreground">Estado:</strong>{" "}
                    <Badge variant={estadoVariant(application.estado)}>
                      {application.estado}
                    </Badge>
                  </p>
                </div>
              </div>

              <div className="flex justify-center gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() =>
                    navigate(
                      `/ver-licitacion/${application.id_tender}/${application.tender.titulo}`
                    )
                  }
                >
                  Ver Licitación
                </Button>
                <Button
                  size="sm"
                  onClick={() =>
                    navigate(
                      application.estado === "ganador"
                        ? `/admin-contrato/${application.id_application}`
                        : `/detalle-postulacion/${application.id_application}`
                    )
                  }
                >
                  {application.estado === "ganador"
                    ? "⭐ Gestionar Contrato"
                    : "Ver Postulación"}
                </Button>
              </div>
            </CardContent>
          </Card>
        ))
      ) : (
        <div className="mt-5 text-center text-muted-foreground">
          <p>No hay postulaciones disponibles con estos filtros.</p>
        </div>
      )}

      <div className="fixed bottom-0 left-0 flex w-full items-center justify-center gap-2 border-t border-border bg-background/95 px-4 py-3 backdrop-blur">
        <Button variant="outline" size="sm" onClick={handlePreviousPage} disabled={page === 1}>
          Atrás
        </Button>
        {renderPaginationButtons().map((p, index) => (
          <Button
            key={index}
            variant={p === page ? "default" : "outline"}
            size="sm"
            onClick={() => setPage(p)}
          >
            {p}
          </Button>
        ))}
        <Button variant="outline" size="sm" onClick={handleNextPage} disabled={page === totalPages}>
          Siguiente
        </Button>
      </div>
    </div>
  );
};

export default InfoPostulaciones;
